import React from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {nomAppareil, texteAccessoires, titreParDefaut, totalPrestations} from "../../../../util/assistantPec";

const euros = (n) => n.toFixed(2).replace(".", ",") + " €";

/** Étape 5 : récapitulatif, remarques, choix des impressions puis enregistrement. */
export default function EtapeRecap({
                                       client, lignes, titre, descriptionTech, description, imprimerEtiquettes, imprimerPapier,
                                       impressionPossible, onChange, onModifier, onRetirer, onAjouter,
                                   }) {
    const total = totalPrestations(lignes);

    return (
        <div>
            <h4>Prise en charge de {client?.fullname}</h4>
            <FormGroup>
                <Label className="small text-muted mb-1">Nom de la prise en charge (laisser vide pour le nom proposé)</Label>
                <Input bsSize="lg" value={titre} placeholder={titreParDefaut(lignes)}
                       onChange={e => onChange({titre: e.target.value})}/>
            </FormGroup>
            {lignes.map((ligne, index) => (
                <div className="assistant-pec-recap" key={index}>
                    <div className="d-flex justify-content-between">
                        <strong className="h4 mb-1">{nomAppareil(ligne.appareil)}</strong>
                        <span>
                            <Button size="sm" outline color="primary" onClick={() => onModifier(index)}>Modifier</Button>
                            <Button size="sm" color="link" className="text-danger" onClick={() => onRetirer(index)}>Retirer</Button>
                        </span>
                    </div>
                    <div className="small">
                        <div><span className="text-muted">Réparation : </span>
                            {ligne.prestations.length
                                ? ligne.prestations.map(p => `${p.title} (${String(p.prix).replace(".", ",")} €)`).join(", ")
                                : "diagnostic"}
                        </div>
                        <div><span className="text-muted">Accessoires : </span>{texteAccessoires(ligne.accessoires, ligne.accessoiresAutre)}</div>
                        {ligne.serial && <div><span className="text-muted">N° de série : </span>{ligne.serial}</div>}
                        {ligne.defauts && <div><span className="text-muted">Panne : </span>{ligne.defauts}</div>}
                        {ligne.code && <div><span className="text-muted">Code : </span>{ligne.code}</div>}
                    </div>
                </div>
            ))}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <Button outline color="primary" onClick={onAjouter}><i className="fa fa-plus mr-2"/>Ajouter un autre appareil</Button>
                {total > 0 && <span className="h4 mb-0">Total estimé : {euros(total)}</span>}
            </div>

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label className="small text-muted">Remarque pour le client (imprimée sur son papier)</Label>
                        <Input type="textarea" rows={2} value={descriptionTech}
                               onChange={e => onChange({descriptionTech: e.target.value})}/>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label className="small text-muted">Note interne (le client ne la voit pas)</Label>
                        <Input type="textarea" rows={2} value={description}
                               onChange={e => onChange({description: e.target.value})}/>
                    </FormGroup>
                </Col>
            </Row>

            {impressionPossible && (
                <div className="assistant-pec-impression">
                    <span className="mr-3">À l'enregistrement, imprimer :</span>
                    <FormGroup check inline>
                        <Label check>
                            <Input type="checkbox" checked={imprimerEtiquettes}
                                   onChange={e => onChange({imprimerEtiquettes: e.target.checked})}/>
                            {" "}les étiquettes ({lignes.length})
                        </Label>
                    </FormGroup>
                    <FormGroup check inline>
                        <Label check>
                            <Input type="checkbox" checked={imprimerPapier}
                                   onChange={e => onChange({imprimerPapier: e.target.checked})}/>
                            {" "}le papier de prise en charge pour le client
                        </Label>
                    </FormGroup>
                </div>
            )}
        </div>
    );
}
